import { motion } from 'motion/react';

const AboutHerosection = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-5 lg:px-20">
      <div className="lg:h-[450px] bg-[#e6e0ff] lg:bg-transparent lg:bg-bg2 bg-cover lg:bg-contain bg-no-repeat xl:bg-cover lg:-mt-20 xl:-mt-28 relative rounded-b-[50px] rounded-t-[50px] lg:rounded-t-none">
        <div className="w-full h-full flex flex-col justify-center xl:justify-end px-4 xl:px-10 pb-8 xl:pb-14 pt-8 lg:pt-0">
          <div className="flex flex-col lg:flex-row justify-between">
            <div className="lg:w-[50%]">
              <motion.div
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="py-3 px-4 montserrat-medium text-primary bg-white rounded-full w-32 flex justify-center mb-5"
              >
                ABOUT US
              </motion.div>
              <motion.h1
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="text-secondary text-4xl xl:text-5xl montserrat-regular mb-4 lg:mb-0"
              >
                A{" "}
                <span className="montserrat-semibold text-primary">
                  Financial Visionary
                </span>{" "}
                in the{" "}
                <span className="montserrat-semibold text-primary">
                  Medical Industry.
                </span>
              </motion.h1>
            </div>
            <div className="lg:w-[40%] flex items-end">
              <motion.p
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 1 }}
                viewport={{ once: true }}
                className="montserrat-regular text-secondary"
              >
                <span className="montserrat-semibold">John Bostjancic,</span>{" "}
                has 30+ years of healthcare finance expertise, leading growth,
                transformations, and M&A at Sonendo, Orthofix, SeaSpine, and
                Integra LifeSciences.
              </motion.p>
            </div>
          </div>
        </div>
        <a
          href="/contact"
          className="hidden lg:block bg-[#E9FF7A] py-3 px-7 absolute top-3 xl:top-10 right-5 xl:right-20 2xl:right-24 montserrat-medium rounded-full text-xl z-30"
        >
          Contact Me
        </a>
      </div>
    </div>
  );
}

export default AboutHerosection